
import taxImage1 from "../Assets/taximage1.jpg"
import taxImage2 from "../Assets/taximage2.jpg"
import taxImage3 from "../Assets/taximage3.jpg"
import taxImage4 from "../Assets/taximage4.jpg"
import taxImage5 from "../Assets/taximage5.jpg"
import taxImage6 from "../Assets/community.jpg"
import taxImage7 from "../Assets/chooseus.jpg"
import AndersonFamilyPhoto from "../Assets/AndersonFamilyPhoto.jpg"
import TawneeAndersonImage from "../Assets/TawneeAndersonPro.jpg"
import '../Styles/AboutUs.css'


let temp = "At  Tawnee Anderson's a Tax Professional with XIT Financial Services LLC, we are more than just a financial planning service; we are a family-owned and operated tax preparation business dedicated to helping individuals and families navigate the complexities of the tax landscape. With years of experience, a deep understanding of tax regulations, and a passion for delivering personalized services, we take pride in being the go-to resource for all your tax needs."
function AboutUs(params) {
    return (
        <div className="AboutUs" >
            <div className="content">
                <div id="aboutusTitle" className=" upright">
                    <br></br>
                    <div className="infoblock">
                        <div>
                            <h2>Meet Tawnee Anderson, a Tax Professional with XIT Financial Services LLC - Your Trusted Partner in Tax Preparation!</h2>
                            <p>
                                Tawnee began her journey doing taxes in 2022. She is currently a consultant with XIT Financial Services LLC. She is excited that she has been able to bring her skills and expertise back to the community she grew up in and loves. With Tawnee as your tax consultant you can expect fast, honest, reliable, and compassionate tax assistance. Along with her tax experience Tawnee has a genuine desire to help others and looks forward to meeting and helping you too.
                            </p>

                        </div>

                        <img src={TawneeAndersonImage}></img>

                    </div>

                </div>

                <div className="infoblock">
                    <img src={AndersonFamilyPhoto}></img>
                    <div>
                        <h2>Our Values:</h2>
                        <p>
                            Family-Centric Approach: We treat our clients like an extension of our family. Your financial success and peace of mind are at the forefront of everything we do.
                        </p>
                    </div>
                </div>
                <div className="infoblock">
                    <div>
                        <h2>Expertise:</h2>
                        <p>
                            With a team of skilled professionals who stay up-to-date with the latest tax regulations, we ensure that you receive accurate advice and services tailored to your unique situation.
                        </p>
                    </div>
                    <img src={taxImage4}></img>
                </div>
                <div className="infoblock">
                    <img src={taxImage5}></img>
                    <div>
                        <h2>Integrity:</h2>
                        <p>
                            Honesty and transparency form the bedrock of our services. You can trust us to handle your financial information with the utmost confidentiality and respect.
                        </p>
                    </div>
                </div>
                <div className="infoblock">
                    <div>
                        <h2>Personalized Attention:</h2>
                        <p>
                            We understand that each client's financial situation is unique. That's why we take the time to listen, understand your goals, and customize our services to best meet your needs.
                        </p>
                    </div>
                    <img src={taxImage1}></img>
                </div>
                <div className="infoblock">
                    <img src={taxImage6}></img>
                    <div>
                        <h2>Community Focus:</h2>
                        <p>
                            We are proud to be a part of this community, and giving back is important to us. We actively engage in local initiatives and events to contribute positively to the neighborhoods we serve.
                        </p>

                    </div>
                </div>
                <div className="infoblock">
                    <div>
                        <h2>Our Services:</h2>
                        <p>
                            From individual tax returns to small business tax planning, Tawnee Anderson  offers a comprehensive range of tax services designed to alleviate the stress of tax season and maximize your financial outcomes. Our services include:
                            <ul>
                                <li>Personal Income Tax Preparation</li>
                                <li>Small Business Tax Preparation and Consultation</li>
                                <li>Tax Problem Resolution</li>
                                <li>Year-Round Tax Advice</li>
                            </ul>
                        </p>

                    </div>
                    <img src={taxImage3}></img>
                </div>
                <div className=" upright">
                    <div>
                        <h2>Why Choose Us:</h2>
                        <p>
                            When you choose Tawnee Anderson as your tax professional, you are not just selecting a tax preparation service; you are choosing a dedicated partner that has your best interests at heart. We are committed to providing accurate, timely, and trustworthy services that empower you to make informed financial decisions.
                            Call, Text or Email Today!
                        </p>
                    </div>
                </div>
                <div >
                    <h2>Contact Us:</h2>
                    <p>
                        <button onClick={() => params.setPath("ContactUs")} className="Question">Have a question?</button> Ready to get started? Reach out to our friendly team today at <a href="mailto:Tawnee.anderson@andersonstaxes.com" style={{ color: 'black' }}>Tawnee.anderson@andersonstaxes.com</a>. We offer a free initial consultation to understand your needs and explore how we can assist you.

                        Thank you for considering Tawnee Anderson as your tax preparation partner. We look forward to helping you achieve your financial goals and ensuring a stress-free tax experience for you and your family.
                        Warm regards,

                        Tawnee and Darren Anderson
                    </p>


                </div>
            </div>
        </div>
    )
}

export default AboutUs;